import { defineComponent as _defineComponent } from 'vue'
import {reactive, ref} from "vue";
import LoginFormBlock from "@/views/pages/auth/login/LoginFormBlock.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'OauthLoginPage',
  setup(__props) {


const backUrl = ref('https://example.com/test/page')


return { __sfc: true,backUrl, reactive, ref, LoginFormBlock }
}

})